import { GQLMerchDecorationTypeType, GQLMerchItemFragment, GQLMerchTileFragment } from '@theprintbar/graphql';
import { getDecorationName } from '../../decoration';
import { Merch } from '../schema';

export function getMerchDecorationMethods(merch: Merch | GQLMerchTileFragment | GQLMerchItemFragment) {
	return merch.decorations.reduce((acc, decoration) => {
		if (!acc[decoration.type]) {
			acc[decoration.type] = getDecorationName(decoration.type);
		}
		return acc;
	}, {} as Record<GQLMerchDecorationTypeType, string>);
}
